export default {
  PersonalCenter: 'PersonalCenter',
  MemberManage: 'Member',
  MemberGroupManage: 'MemberGroupManage',
  RightsManage: 'RightsManage',
  Confirm: 'Confirm',
  Clear: 'Clear',
  NextPage: 'NextPage',
  PreviousPage: 'PreviousPage',
  CreateTime: 'CreateTime',
  NoDataAvailable: 'NoDataAvailable',
  RegionSelection: 'RegionSelection',
  ContactInformation: 'Contact',
  Pass: 'Pass',
  Reject: 'Reject',
  OperationSuccessful: 'success!',
  Attachment: 'Attachment',
  Download: 'Download',
  // 一级菜单部分
  WorkBench: 'Workbench',
  Project: 'Project',
  Customer: 'Customer',
  IntelligenceManage: 'Intelligence',
  ClueManage: 'Clue',
  CaseManage: 'Case',
  MemberManaget: 'Member',
  SettlementCenter: 'Settlement',
  Tools: 'Tools',
  SupplierManagement: 'Supplier',
  IntellectualPropertySaaS: 'IPSaaS',

  // 二级菜单部分
  ProjectList: 'ProjectList',
  AndunClue: 'AndunClue',
  PendingReview: 'PendingReview',
  All: 'All',
  CluesForTesting: 'CluesForTesting',
  VendorClues: 'VendorClues',
  AndunCase: 'AndunCase',
  CivilCase: 'CivilCase',
  CriminalCase: 'CriminalCase',
  AdministrativeCase: 'AdministrativeCase',
  VendorCase: 'VendorCase',
  InvoiceManage: 'InvoiceManage',
  InvoiceList: 'InvoiceList',
  CopyrightInfringe: 'CopyrightInfringe',
  OnlineMonitor: 'OnlineMonitor',
  OfflineMonitor: 'OfflineMonitor',
  OwnershipSearch: 'OwnershipSearch',
  PatentSearch: 'PatentSearch',
  // 工作台部分
  DataOverview: 'DataOverview',
  AddNewClues: 'AddNewClues',
  AnnualNewClues: 'AnnualNewClues',
  MonthlyNewClues: 'MonthlyNewClues',
  units: 'units',
  AddNewCase: 'AddNewCase',
  NewCasesInTheYear: 'NewCasesInTheYear',
  MonthlyNewCases: 'MonthlyNewCases',
  CaseClosed: 'CaseClosed',
  AccumulatedNumberOfClosed: 'AccumulatedNumberOfClosed',
  AccumulatedNumberOfClosedCasesForTheYear:
    'AccumulatedNumberOfClosedCasesForTheYear',
  CompensationPayment: 'CompensationPayment',
  Amount: 'Amount',
  CumulativeTotalAmount: 'CumulativeTotalAmount',
  ClueCase: 'Clue-Case',
  Yuan: 'Yuan',
  TotalCompensationAmount: 'TotalCompensationAmount',
  AccumulatedNumberOfCases: 'AccumulatedNumberOfCases',
  AccumulatedNumberOfclues: 'AccumulatedNumberOfclues',
  EvidencePendingEvidence: 'Evidence - PendingEvidence',
  CasesWithEvidenceObtained: 'CasesWithEvidenceObtained',
  CasesPendingEvidenceCollection: 'CasesPendingEvidenceCollection',
  OngoingCasesTerminatedCases: 'OngoingCases - TerminatedCases',
  NumberOfOngoingCases: 'NumberOfOngoingCases',
  NumberOfTerminatedCases: 'NumberOfTerminatedCases',
  DataAnalysisOfInfringementMethods: 'DataAnalysisOfInfringementMethods',
  SalesChannelDataAnalysis: 'SalesChannelDataAnalysis',
  ClueDataAnalysis: 'ClueDataAnalysis',
  CaseDataAnalysis: 'CaseDataAnalysis',
  DataStatistics: 'DataStatistics',
  DistributionOfCluesByRegion: 'DistributionOfCluesByRegion',
  DistributionOfLawyerPopulation: 'DistributionOfLawyerPopulation',
  DistributionOfOngoingCasesByRegion: 'DistributionOfOngoingCasesByRegion',
  AuditTrends: 'AuditTrends',
  Online: 'Online',
  Offline: 'Offline',
  CustomerData: 'Customer Data',
  DetailedData: 'Detailed data',
  ClueVolume: 'NumberOfclues',
  //  项目列表部分
  Status: 'Status',
  ProjectName: 'ProjectName',
  PleaseSelect: 'PleaseSelect',
  PleaseInput: 'PleaseInput',
  ProjectCycle: 'ProjectCycle',
  // 项目详情
  ProjectStatus: 'ProjectStatus',
  ProjectRemarks: 'ProjectRemarks',
  ProjectOverview: 'ProjectOverview',
  IntellectualProperty: 'IntellectualProperty',
  BillOfMaterials: 'BillOfMaterials',
  InfringementMap: 'InfringementMap',
  NumberOfClues: 'NumberOfClues',
  Add: 'Add',
  Delete: 'Delete',
  RightsNumber: 'RightsNumber',
  RightsType: 'RightsType',
  TrademarkClassification: 'Classification',
  PatentClassification: 'PatentClassification',
  RightsHolder: 'RightsHolder',
  FileName: 'FileName',
  rightTitle: 'rightTitle',
  statusRights: 'statusRights',
  descriptionRights: 'descriptionRights',
  PlaintiffAttorney: 'PlaintiffAttorney',
  DefendantLegalRepresentative: 'DefendantLegalRepresentative',
  opposingPartyPresent: 'opposingPartyPresent',
  trialProceeding: 'trialProceedings',
  courtDocuments: 'courtDocuments',
  JudgmentDate: 'date of judgment',
  dateReceipt: 'date of receipt',
  judgmentAmount: 'judgmentAmount',
  opposingParty: 'Amount of litigation',
  excerptJudgment: 'excerptJudgment',
  judgment: 'judgment',
  judgmentResult: 'judgmentResult',
  paymentRecord: 'paymentRecord',
  receivableAmount: 'receivableAmount',
  actualAmountReceived: 'actualAmountReceived',
  closureDate: 'closureDate',
  caseClosureMethod: 'caseClosureMethod',
  accountsReceivable: 'accountsReceivable',
  amountCollected: 'amountCollected',
  caseResolutionDetail: 'caseResolutionDetail',
  litigationAnalysis: 'litigationAnalysis',
  confirmationStatus: 'confirmationStatus',
  pendingConfirmation: 'pendingConfirmation',
  closingDocument: 'closingDocument',
  confirmed: 'confirmed',
  paymentDate: 'paymentDate',
  compensationAmount: 'compensationAmount',
  litigationRefund: 'litigationRefund',
  payingEntity: 'payingEntity',
  recipientPayment: 'recipientPayment',
  receiptDate: 'receiptDate',
  mediationParty: 'mediationParty',
  mediationContent: 'mediationContent',
  mediationAmount: 'mediationAmount',
  auditResult: 'auditResult',
  auditRemarks: 'auditRemarks',
  mediationOutcome: 'mediationOutcome',
  mediationAgreement: 'mediationAgreement',
  mediationReview: 'mediationReview',
  executionCaseNumber: 'executionCaseNumber',
  NoExecution: 'No execution results available at the moment',
  filingFee: 'filingFee',
  terminationExecutionDate: 'terminationExecutionDate',
  reasonTerminationExecution: 'reasonTerminationExecution',
  reasonPayment: 'reasonPayment',
  executionAmount: 'executionAmount',
  appendixEnforcementOutcome: 'appendixEnforcementOutcome',
  appendixEnforcementApplication: 'appendixEnforcement',
  NoExecutionRequired: 'NoExecutionRequired',
  partyWithdrawLawsuit: 'partyWithdrawLawsuit',
  reasonWithdrawalLawsuit: 'reasonWithdrawalLawsuit',
  attachmentSubpoena: 'attachmentSubpoena',
  beenApproved:
    'May I ask if this request for dismissing the lawsuit has been approved?',
  partySettlement: 'partySettlement',
  settlementAmount: 'settlementAmount',
  releaseRemarks: 'releaseRemarks',
  settlementOutcome: 'settlementOutcome',
  settlementAgreement: 'settlementAgreement',
  settlementReview: 'settlementReview',
  beenReviewed: 'May I ask if it has been reviewed',
  thisSettlementProposal: 'this settlement proposa?',
  thisSettlementMediation: 'this settlement mediation?',

  // 情报管理
  Genplaceholder: 'Shop/Product/Reporter',
  InvestigationArea: 'Area',
  InvestigationDate: 'Date',
  AllocationStatus: 'Status',
  AssignedTeam: 'AssignedTeam',
  ProductName: 'ProductName',
  StoreName: 'StoreName',
  UnitPrice: 'UnitPrice',
  StoreAddress: 'StoreAddress',
  MonthlySalesVolume: 'MonthlySalesVolume',
  Remarks: 'Remarks',
  Reporter: 'Reporter',
  AllocationTime: 'Allocationtime',
  VerificationStatus: 'VerificationStatus',
  VerificationTime: 'VerificationTime',

  // 线索管理
  BatchOperation: 'BatchOperation',
  BulkApproval: 'BulkApproval',
  BulkRejection: 'BulkRejection',
  Share: 'Share',
  Export: 'Export',
  ExportAll: 'ExportAll',
  ExportSelected: 'ExportSelected',
  reviewedClueSearch: 'Project/StoreName/ClueNumber/subject',
  ChannelReviewedClueSearch: 'StoreName/ClueNumber',
  InfringementArea: 'Area',
  InvestigationTime: 'Time',
  InfringementMethod: 'Method',
  ClueType: 'ClueType',
  reportTime: 'reportTime',
  Test: 'Test',
  Serial: 'Serial',
  Intelligence: 'Intelligence',
  PushTime: 'PushTime',
  Vendor: 'Vendor',
  InfringingLink: 'InfringingLink',
  InvestigationAddress: 'InvestigationAddress',
  Manufacturer: 'Manufacturer',
  ReportTeam: 'ReportTeam',
  ShopkeepID: 'ShopkeepID',
  ReviewStatus: 'ReviewStatus',
  AuditTime: 'auditTime',
  Approved: 'Approved',
  Rejected: 'Rejected',
  ReviewComment: 'ReviewComment',
  Note: 'Note',
  CaseStatus: 'CaseStatus',
  BulkExportImages: 'BulkExportImages',
  Yes: 'Yes',
  No: 'No',
  TestPurchase: 'TestPurchase',
  ReasonRejection: 'Reason',

  // 驳回表单
  ReasonError: 'Reason for rejection cannot be empty',
  ReasonReview: 'Review',
  ReasonReviewError: 'Reason for review cannot be empty',
  notesError: 'Please fill in the remarks',
  max512Error: 'Cannot exceed 512 characters',
  max32Error: 'Cannot exceed 32 characters',
  max16Error: 'Cannot exceed 16 characters',
  NameCannot: 'Name cannot be empty',

  // 线索详情
  BasicInformation: 'BasicInformation',
  InfringingProduct: 'InfringProduct',
  SalesVolume: 'SalesVolume',
  SalesChannel: 'SalesChannel',
  PlatformName: 'PlatformName',
  BulkOperation: 'BulkOperation',
  StoreLink: 'StoreLink',
  ProductLink: 'ProductLink',
  NoVendor: 'No sellers available at the moment',
  NoManufacturer: 'No manufacturers available at the moment',
  TestShop: 'TestShop',
  TestShopImage: 'TestShopImage',
  NoTestShop: 'No purchasing information available',
  sendSamples: 'sendSamples',
  courierCompany: 'courierCompany',
  trackingNumber: 'trackingNumber',
  senderName: 'senderName',
  sender: 'sender',
  senderRegion: 'senderRegion',
  senderFullAddress: 'senderFullAddress',

  // 当事人信息
  EntityNature: 'EntityNature',
  EntityType: 'EntityType',
  NatureBusiness: 'NatureBusiness',
  EnterpriseCompany: 'EnterpriseCompany',
  Individual: 'Individual',
  EntityTag: 'EntityTag',
  proprietorship: 'proprietorship',
  BusinessEntity: 'BusinessEntity',
  IDNumber: 'IDNumber',
  EntityRegion: 'EntityRegion',
  EntityName: 'EntityName',
  OpposingPartyDetail: 'OpposingPartyDetail',
  BillingEntity: 'BillingEntity',
  POSEntity: 'POSEntity',
  CreditCode: 'CreditCode',
  LegalRepresentative: 'Representative',
  Operator: 'Operator',
  BusinessRegistrationAddress: 'Address',
  determinationImage: 'determinationImage',
  ManufacturerName: 'ManufacturerName',
  determinationDescription: 'Description',
  UpdateTime: 'UpdateTime',
  BusinessChange: 'Change',
  BusinessAnomaly: 'Anomaly',
  DishonestyInformation: 'Information',
  AdministrativePenalty: 'Penalty',
  JudicialVerdict: 'Verdict',
  CourtAnnouncement: 'Announcement',
  CourtHearingNotice: 'Notice',
  Debtor: 'Debtor',

  // 案件列表
  CaseSearchInput: 'CaseCode/Counterparty/ClueCode/ShopName/Vendor/Manufacturer',
  CaseSupplierCaseSearchInput: 'CaseCode/ClueCode',
  CaseArea: 'CaseArea',
  CaseType: 'CaseType',
  EvidenceStatus: 'EvidenceStatus',
  Hasmanufacturer: 'Hasmanufacturer',
  SelectTime: 'SelectTime',
  CaseProgress: 'CaseProgress',
  CaseCode: 'CaseCode',
  OpposingParty: 'OpposingParty',
  TerminationReason: 'TerminationReason',
  // 案件详情
  CaseTerminated: 'CaseTerminated',
  Termination: 'Termination',
  Restoration: 'Restoration',
  ReviewTerminationApplication: 'ReviewTerminationApplication',
  RelatedCases: 'RelatedCases',
  Memo: 'Memo',
  HandlingTeam: 'HandlingTeam',
  CaseNote: 'CaseNote',
  ClueDetail: 'ClueDetail',
  CaseEvidence: 'CaseEvidence',
  CaseProcess: 'CaseProcess',
  CaseLog: 'CaseLog',
  CaseMemo: 'CaseMemo',
  ClueNumber: 'ClueNumber',
  Evidence: 'Evidence',
  EvidenceDetail: 'EvidenceDetail',
  EvidenceType: 'EvidenceType',
  NotarialEvidence: 'Notarial certificate/Evidence number',
  EvidenceCollectionTime: 'EvidenceCollectionTime',
  SignatureNotarizationTime: 'signature/Notarization time',
  NotarialCertificateAttachment: 'NotarialCertificateAttachment',
  NoMemo: 'No memo information available',
  LetterRecordLawyer: 'Letter record(Lawyerletter)',
  LetterRecordComplaint: 'Letter record(Online complaint)',
  TrackingNumber: 'TrackingNumber',
  OnlineDocument: 'OnlineDocument',
  DateSendLetter: 'DateSendLetter',
  LetterContent: 'LetterContent',
  MethodSendingLetter: 'MethodSendingLetter',
  receipt: 'receipt',
  LogisticsInformation: 'LogisticsInformation',
  ComplaintTime: 'ComplaintTime',
  ComplaintWebsite: 'ComplaintWebsite',
  ComplaintPlatform: 'ComplaintPlatform',
  ComplaintContent: 'ComplaintContent',
  ApplicationMaterial: 'ApplicationMaterials',
  MaterialDelivery: 'MaterialDelivery',
  ReasonCase: 'ReasonCase',
  InfringementRights: 'InfringementRights',
  Attorneyatlaw: 'Attorneyatlaw',
  SubjectMatterLitigation: 'SubjectMatterLitigation',
  reasonableExpenses: 'reasonableExpenses',
  JurisdictionalCourt: 'JurisdictionalCourt',
  AffixingPersonalSeal: 'AffixingPersonalSeal',
  NoMoment: 'No relevant information available at the moment',
  Sender: 'Sender',
  Recipient: 'Recipient',
  MailingTime: 'MailingTime',
  Mailing: 'Mailing',
  SelfPickUp: 'SelfPickUp',
  MailMethod: 'MailMethod',
  CourierCompany: 'CourierCompany',
  ContentsPackage: 'ContentsPackage',
  Received: 'Received',
  TrackShipment: 'TrackShipment',
  SubmitDocument: 'SubmitDocument',
  litigationCoordination: 'litigationCoordination',
  Acceptance: 'Acceptance',
  SubmissionDate: 'SubmissionDate',
  SubmissionMethod: 'SubmissionMethod',
  receivCourt: 'receivCourt',
  testingPeriod: 'testingPeriod',
  summons: 'summons',
  preservation: 'preservation',
  publicNotice: 'publicNotice',
  exchangeOfEvidence: 'exchangeOfEvidence',
  jurisdictionalObjection: 'jurisdictionalObjection',
  courtHearTime: 'courtHearTime',
  courtJurisdiction: 'courtJurisdiction',
  presidingJudge: 'presidingJudge',
  assistant: 'assistant',
  subpoenaAttachment: 'subpoenaAttachment',
  typesOfInterimMeasures: 'typesOfInterimMeasures',
  respondent: 'respondent',
  amountInterimMeasure: 'amountInterimMeasure',
  interimMeasureDocuments: 'interimMeasureDocuments',
  formNotice: 'formNotice',
  noticePeriod: 'noticePeriod',
  noticeExpenses: 'noticeExpenses',
  noticeMaterials: 'noticeMaterials',
  evidenceExchangeDeadline: 'evidenceExchangeDeadline',
  location: 'location',
  participants: 'participants',
  opposingEvidence: 'opposingEvidence',
  receivingCourt: 'receivingCourt',
  dateAcceptance: 'dateAcceptance',
  deadlineSubmittingEvidence: 'deadlineSubmittingEvidence',
  to: 'to',
  noticeAcceptance: 'noticeAcceptance',
  paymentReceipt: 'paymentReceipt',
  attendingLawyer: 'attendingLawyer',
  contractedSupplier: 'contractedSupplier',
  investigationCaseNumber: 'investigationCaseNumber',
  jointInvestigationPeriod: 'estimated joint investigation period',

  // 成员管理
  AddNewMember: 'AddNewMember',
  moreOperations: 'moreOperations',
  JoiningTime: 'JoiningTime',
  AreaJurisdiction: 'Jurisdiction',
  DownloadQRCode: 'DownloadQRCode',
  DisableConfirmation: 'DisableConfirmation',
  DisableAccount:
    'May I confirm if you want to disable the account of this member?',
  EnableConfirmation: 'EnableConfirmation',
  EnableAccount: 'Are you sure you want to enable the account of this member?',
  MemberDetail: 'MemberDetail',
  BusinessPermissions: 'BusinessPermissions',
  CopyLink: 'CopyLink',
  Role: 'Role',
  AccountStatus: 'AccountStatus',
  AccountInformation: 'AccountInformation',
  WeChatID: 'WeChatID',
  Unbind: 'Unbind',
  SetPassword: 'SetPassword',
  ModifyAccount: 'ModifyAccount',
  editOnly:
    'You can only make one modification to your account. If you are sure about the modification, please fill in the following information',
  OriginalAccount: 'OriginalAccount',
  NewAccount: 'NewAccount',
  Address: 'Address',
  IsAdministrator: 'IsAdministrator',
  ViewDataPermission: 'ViewDataPermission',
  AccountCannot: 'Account cannot be empty',
  password: 'password',
  PasswordCannot: 'Password cannot be empty',
  validEmail: 'Please enter a valid email',
  region: 'region',
  SelectAdministrator: 'Please select whether you are an administrator',
  Save: 'Save',
  ReasonErrorJinYong: 'Please provide the reason for disabling',
  ReasonDisable: 'ReasonDisable',

  // 开票管理
  InvoiceSearch: 'Invoice number/Project/Billing entity',

  InvoiceDate: 'InvoiceDate',
  ApplicationDate: 'Application',
  Applicant: 'Applicant',
  InvoiceNumber: 'InvoiceNumber',
  InvoiceIssuingUnitName: 'InvoiceIssuingUnitName',
  InvoiceAmount: 'InvoiceAmount',
  InvoiceType: 'InvoiceType',
  InvoiceStatus: 'InvoiceStatuss',
  // 开票详情
  InvoiceInformation: 'InvoiceInformation',
  CustomerName: 'CustomerName',
  TaxpayerIdentificationNumber: 'TaxpayerIdentificationNumber',
  PhoneNumber: 'PhoneNumber',
  IncomeType: 'IncomeType',
  AffiliatedCompany: 'AffiliatedCompany',
  AssociatedContract: 'AssociatedContract',
  InvoiceContent: 'InvoiceContent',
  Nature: 'Nature',
  InvoiceRemark: 'InvoiceRemark',
  SettlementStatementInformation: 'SettlementStatementInformation',
  ContractDetail: 'ContractDetail',
  ContractName: 'ContractName',
  ContractNumber: 'ContractNumber',
  Creator: 'Creator',
  SigningDate: 'SigningDate',
  ContractValidityPeriod: 'ContractValidityPeriod',
  ContractType: 'ContractType',
  SettlementNumber: 'SettlementNumber',
  SettlementType: 'SettlementType',
  NumberOfCases: 'NumberOfCases',
  Payee: 'Payee',
  RiskAgencyFeeIncludingCosts: 'Risk agency fee (including costs)',
  CustomerAuthorizationFee: 'CustomerAuthorizationFee',
  SettlementAmount: 'SettlementAmount',
  Total: 'Total',
  ProjectAffiliation: 'ProjectAffiliation',
  TotalSettlementAmount: 'Total settlement amount (paid by Party B)',
  CaseInformation: 'CaseInformation',
  CaseNumberAnHao: 'CaseNumber',
  LitigationRefund: 'LitigationRefund',
  // 工具
  ViewMonitoringTask: 'ViewMonitoringTask',
  AddMonitoringTask: 'AddMonitoringTask',
  TaskName: 'TaskName',
  MonitoringKeyword: 'MonitoringKeyword',
  OnlineSearchInput: 'TaskName/MonitoringKeyword',
  view: 'view',
  Start: 'Start',
  StartStatus: 'StartStatus',
  startTask: 'Do you want to start this task?',
  monitoringPlatform: 'monitoringPlatform',
  searchKeyword: 'searchKeyword',
  sortMethod: 'sortMethod',
  defaultSort: 'defaultSort',
  highToLowPrice: 'highToLowPrice',
  requiredKeyword: 'requiredKeyword',
  OnlyTheDataContain:
    'After filling in the keyword, only the data containing at least one of the keyword in the product title will be retrieved.',
  separatedByCommas: 'Multiple keywords separated by commas',
  automatically:
    'After filling in the keyword, any product title containing one of the keywords will be automatically excluded or ignored',
  negativeExpression: 'negativeExpression',
  MaximumNumber: 'MaximumNumber',
  entries:
    'Please enter an integer of 100. minimum  100 entries, maximum  5000 entries',
  enterNumbe: 'Please enter a number',
  enterInteger: 'Please enter an integer',
  greaterThan100: 'Please enter an integer greater than 100',
  cannotExceed5000: 'The maximum number of data entries cannot exceed 5000',
  cannotBeEmpty: 'The task name cannot be empty',
  leastOnePlatform: 'Please select at least one platform',
  searchKeywordCannot: 'The search keyword cannot be empty',
  serialNumber: 'serialNumber',
  PlatformType: 'PlatformType(MonitoringStatus)',
  monitorProduct: 'monitorProduct',
  monitorStore: 'monitorStore',
  MonitorStartTime: 'MonitorStartTime',
  negation: 'negation',
  summary: 'summary',
  product: 'product',
  platformDataStatistic: 'platformDataStatistic',
  priceRangeStatistic: 'priceRangeStatistic',
  Top10SellingStore: 'Top10SellingStore',
  Top10SellingProduct: 'Top10SellingProduct',
  numberProduct: 'numberProduct',
  price: 'price',
  TaobaoNumber: 'Taobao Numberproduct',
  TmallNumber: 'Tmal Numberproduct',
  JDComNumber: ' JD.com Numberproduct',
  AlibabaNumber: 'Alibaba Numberproduct',
  PinduoduoNumber: 'Pinduoduo Numberproduct',
  SelectCategory: 'SelectCategory',
  MonitorScope: 'MonitorScope',
  MonitorCategorie: 'MonitorCategorie',
  CumulativeMonitorCount: 'CumulativeMonitorCount',
  MonitoringStatu: 'MonitoringStatu',
  MonitoringRetrievalTime: 'MonitoringRetrievalTime',
  PleaseInputkeyword: 'PleaseInputkeyword',
  image: 'image',
  Type: 'Type',
  QuantityGoods: 'QuantityGoods',
  MinimumSalesVolume: 'MinimumSalesVolume',
  MaximumSalesVolume: 'MaximumSalesVolume',
  SalesRange: 'SalesRange',
  shipment: 'shipment',
  SellingPrice: 'SellingPrice',
  Day30SalesVolume: '30DaySalesVolume',
  oldOnlineMonitor: 'OnlineMonitor（old）',

  // ——————————————
  TaskHall: 'Task hall',
  DoingTask: 'Doing tasks',
  Team: 'Team',
  Financ: 'Financ',
  Riskloan: 'Risk loan',
  ClueTask: 'Clue task',
  PublicTask: 'public task',
  DesignateTask: 'designate task',
  CaseTask: 'Case task',
  PublicCase: 'public case',
  DesignateCase: 'designate case',
  Clue: 'Clue find',
  Case: 'Clue task',
  MyTask: 'My task',
  AllTask: 'All task',
  MyResult: 'My result',
  AllResult: 'All result',
  MyCase: 'My case',
  Inprogress: 'In progress',
  Ended: 'Ended',
  AllCase: 'All case',
  AwaitAllocationCase: 'Await Allocation Case',
  MyTransactionCase: 'My Transaction Case',
  Processing: 'Processing',
  Transacted: 'Transacted',
  AllTransactionCase: 'All Transaction Case',
  TeamManagement: 'Team management',
  JobPermissions: 'Job Permissions',
  MyCenter: 'My center',
  ResetPwd: 'Reset pwd',
  Exit: 'Exit',
  Name: 'Name',
  Sex: 'Sex',
  Duties: 'Duties',
  Account: 'Account',
  Mail: 'Mail',
  Mobile: 'Mobile',
  Operating: 'Operating',
  AddEmployee: 'Add employee',
  editIcon: 'edit',
  prohibitIcon: 'prohibit',
  resetIcon: 'reset password',
  enableIcon: 'enable',
  'name/account/tel': 'name / account / mobile',
  tortSubjectProperty: {
    P: 'ID number',
    E: 'Legal Representative',
    I: 'operator'
  },
  isEnable: {
    Y: 'Enable',
    N: 'Disabled'
  },
  cancel: 'cancel',
  reset: 'reset',
  sure: 'sure',
  forbidUserModal: 'Are you sure to disable the user?',
  resetModal: 'Are you sure to reset password the user?',
  enableModal: 'Are you sure to enable users ?',
  BatchEnableList: {
    Y: 'Batch operation',
    N: 'Batch disabled'
  },
  role: {
    All: 'All'
  },
  lawyerList: {
    lawyer: 'lawyer',
    'not-lawyer': 'NonLawyer'
  },
  'identity-information': 'Identity Information',
  certificateType: {
    IC: 'Identity Card',
    PP: 'Passport'
  },
  'ID-type': 'ID Type',
  projectState: {
    R: 'Processing',
    P: 'Time out',
    A: 'Archive',
    E: 'Expired'
  },
  allocationState: {
    P: 'PendingAllocation',
    E: 'Allocated'
  },
  verifyState: {
    P: 'ToBeVerified',
    E: 'verified',
    R: 'verificationInvalid'
  },
  CaseState: {
    '1': 'CaseClosed',
    '0': 'CasePending'
  },
  ClueReviewState: {
    C: 'Customer confirmation',
    CP: 'ustomer audits are passed',
    CD: 'Customer review declined'
  },
  // 线索驳回
  ClueReject: {
    A1: 'is franchise store',
    A2: 'Filed a lawsuit',
    A3: 'Incomplete data',
    A4: 'Genuine'
  },
  // 线索通过
  ClueAgree: {
    A1: 'is not a franchise store',
    A2: 'Confirmed as counterfeit'
  },
  // 案件进度
  CivilCaseProgressState: {
    PN: 'Plan',
    SR: 'Send Letter',
    RR: 'Case Filing',
    PL: 'Pretrial',
    CG: 'Court Hearing',
    JT: 'Judgment',
    EC: 'Archived',
    TN: 'Terminated',
    AC: 'Payment Received',
    EN: 'Execution',
    RE: 'Settlement',
    ME: 'Mediation',
    WD: 'Withdrawn'
  },
  // 案件类型
  CaseTypeState: {
    online: 'online',
    offline: 'offline'
  },
  // 取证状态
  EvidenceState: {
    P: 'Pending evidence',
    W: 'Pending issuance',
    A: 'Issued'
  },
  // 案件状态
  CaseStates: {
    HH: 'In progress',
    TN: 'Terminated',
    ED: 'Ended'
  },
  // 刑事案件进度
  CivilCaseProgressState1: {
    CRAP: 'Criminal Application',
    RR: 'Case Filing',
    INVE: 'Investigation Action',
    REPR: 'Review Prosecution',
    JT_BB: 'Judgment',
    EC_EC: 'Archived'
  },
  // 行政案件进度
  CivilCaseProgressState2: {
    ADAP: 'Administrative Application',
    RR: 'Case Filing',
    INVE: 'Investigation Action',
    EC_EC: 'Archived'
  },
  // 账号状态
  AccountState: {
    false: 'prohibit',
    true: 'enable'
  },
  // 性别
  SexState: {
    F: 'female',
    M: 'male'
  },
  // 到款状态
  paymentRecordState: {
    P: 'confirmed',
    E: 'pendingConfirmation'
  },
  ec_channel: {
    TT: 'Taobao',
    TS: 'Taote',
    TM: 'Tmall',
    AL: 'Alibaba',
    JD: 'JD.com',
    SN: 'Suning',
    YH: 'YHD',
    PD: 'Pinduoduo',
    OT: 'Other',
    DY: 'Douyin'
  },
  tort_type: {
    E_EC: 'E-commerce platform',
    S_ST: 'Physical store',
    S_FA: 'Factory',
    S_OT: 'Other',
    E_WL: 'Web link'
  },
  // 开票状态

  InvoiceState: {
    P: 'Invoicing',
    E: 'Invoice approved',
    R: 'Invoice rejected'
  },
  // 	审核状态

  ReviewState: {
    '10': 'Under review',
    '40': 'Rejected and terminated',
    '99': 'Review approved'
  },
  onlinePlatformState: {
    '1': 'Taobao',
    '2': 'Tmall',
    '3': 'JD.com',
    '5': 'Alibaba',
    '6': 'Pinduoduo'
  },
  IpState: {
    正常: 'Normal',
    暂缓: 'Suspended',
    终止: 'Terminated',
    未授权: 'Unauthorized'
  },
  materialsListState: {
    CM: 'Project collaboration',
    EM: 'Entrusted materials',
    LD: 'Litigation document',
    MM: 'Main materials',
    NE: 'Evidence of notability',
    OO: 'Others',
    PO: 'Project originals',
    RP: 'Main materials',
    WD: 'Prior/related cases',
    WM: 'Ownership materials'
  },
  CaseProgressState: {
    LL: 'Letter sent',
    PN_BB: 'Litigation plan',
    RR: 'Filing a lawsuit',
    PL: 'Pre-trial',
    CG_CG: 'Court hearing',
    JT_BB: 'Judgment',
    CO_CO: 'Execution',
    ST: 'Settlement',
    EC_EC: 'Case closed',
    RE_AP: 'reconciliation',
    TR_ME: 'Mediation'
  },
  // 材料类型
  AttachmentState: {
    PA: 'Power of Attorney',
    IT: 'complaint'
  }
}



// WEBPACK FOOTER //
// ./src/locale/lang/en-US.js